module.exports = __webpack_public_path__ + "static/media/hot-cat-banner-item-6.259b1dc8.png";